__turbopack_context__.v({
  "closeButton": "TaskLogViewer-module__4BGcCq__closeButton",
  "columnHeader": "TaskLogViewer-module__4BGcCq__columnHeader",
  "copy-confirmation": "TaskLogViewer-module__4BGcCq__copy-confirmation",
  "copyEntryButton": "TaskLogViewer-module__4BGcCq__copyEntryButton",
  "emptyState": "TaskLogViewer-module__4BGcCq__emptyState",
  "feedback": "TaskLogViewer-module__4BGcCq__feedback",
  "filterBar": "TaskLogViewer-module__4BGcCq__filterBar",
  "filterButton": "TaskLogViewer-module__4BGcCq__filterButton",
  "followButton": "TaskLogViewer-module__4BGcCq__followButton",
  "header": "TaskLogViewer-module__4BGcCq__header",
  "headerActions": "TaskLogViewer-module__4BGcCq__headerActions",
  "level": "TaskLogViewer-module__4BGcCq__level",
  "liveButton": "TaskLogViewer-module__4BGcCq__liveButton",
  "liveControls": "TaskLogViewer-module__4BGcCq__liveControls",
  "liveDot": "TaskLogViewer-module__4BGcCq__liveDot",
  "logRow": "TaskLogViewer-module__4BGcCq__logRow",
  "metaBar": "TaskLogViewer-module__4BGcCq__metaBar",
  "metaSpacer": "TaskLogViewer-module__4BGcCq__metaSpacer",
  "pulse": "TaskLogViewer-module__4BGcCq__pulse",
  "receiving": "TaskLogViewer-module__4BGcCq__receiving",
  "searchField": "TaskLogViewer-module__4BGcCq__searchField",
  "spin": "TaskLogViewer-module__4BGcCq__spin",
  "spinning": "TaskLogViewer-module__4BGcCq__spinning",
  "statusBadge": "TaskLogViewer-module__4BGcCq__statusBadge",
  "taskControlButton": "TaskLogViewer-module__4BGcCq__taskControlButton",
  "taskMeta": "TaskLogViewer-module__4BGcCq__taskMeta",
  "timestamp": "TaskLogViewer-module__4BGcCq__timestamp",
  "titleBlock": "TaskLogViewer-module__4BGcCq__titleBlock",
  "toolbar": "TaskLogViewer-module__4BGcCq__toolbar",
  "viewer": "TaskLogViewer-module__4BGcCq__viewer",
  "viewport": "TaskLogViewer-module__4BGcCq__viewport",
  "virtualCanvas": "TaskLogViewer-module__4BGcCq__virtualCanvas",
});
